<template>
  <div id="treeVos">
    <vue2-org-tree :data="dataList" />
  </div>
</template>
  
  <script>
import { uploadMy ,treeListDataTree} from "@/api";
export default {
  name: "baota",
  data() {
    return {
      // msg: 'Welcome to Your Vue.js App',
      htmlTitle: "宝塔式",
      isDownload: false,
      pdfId:'',
      dataList: {}
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.pdfId = this.$route.query.pdfId;
    this.isDownload = this.$route.query.isDownload;
    this.htmlTitle = this.$route.query.htmlTitle;
    treeListDataTree({logyId:this.id}).then(res =>{
      if(res.data.length >= 1){
this.dataList = res.data[0];
      }
      
    })
  },
    updated() {
    this.$nextTick(() => {
      this.getPdf(
        document.getElementById("treeVos"),
        this.htmlTitle,
        this.isDownload
      ).then((res) => {
        if (res) {
          console.log("准备上传");
          this.UploadPdf(res);
        } else {
          console.log("不上传");
        }
      });
    });
  },
  methods: {
    //上传pdf接口
    UploadPdf(res) {
      //res拿到base64的pdf
      let pdfBase64Str = res;
      var myfile = this.dataURLtoFile(pdfBase64Str, this.title + ".pdf"); //调用一下下面的转文件流函数
      var formdata = new FormData();
      formdata.append("file", myfile); // 文件对象
      formdata.append("pdfId", this.pdfId); // 文件对象
      //该uploadMy为接口，直接以formdata格式传给后台
      uploadMy(formdata)
        .then((res) => {
          console.log("上传pdf接口", res);
        })
        .catch((err) => {
          console.log("上传pdf接口", err);
        });
    },
    /*
将base64转换为文件,接收2个参数，第一是base64，第二个是文件名字
最后返回文件对象
*/
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
</style>
  


// WEBPACK FOOTER //
// src/view/baota.vue